
import vtc from "../../../assets/images/vtc.svg";
import vtc2 from "../../../assets/images/vtc2.svg";
import vtc6 from "../../../assets/images/vtc6.svg";
import vtv3 from "../../../assets/images/vtv3.svg";
import vinh_phu from "../../../assets/images/vinh_phu.svg";


export default function Parte()
{
    return(
        <div className="w-full lg:px-[120px] lg:py-[40px]">
            <div className="container mx-auto p-3">
<div className="w-full flex flex-col gap-3 lg:flex-col lg:items-center lg:justify-center">
    <p className="text-[28px] text-[#033F6A] font-semibold lg:text-[36px]">Đối tác của chúng tôi</p>
    <p>BlueSkyIT không chỉ phục vụ các doanh nghiệp và tổ chức lớn mà còn đồng hành cùng hàng ngàn khách hàng nhỏ lẻ trong nhiều lĩnh vực khác nhau.</p>
    <p> Chúng tôi cam kết mang đến các giải pháp phù hợp nhất cho từng nhu cầu khách hàng</p>
</div>
<div>
          <div className="hidden md:block lg:block w-full mt-4">
            <div className="flex w-full items-center gap-3">
              <div className="w-1/5 h-[78px] px-[16px] py-[16px] rounded-[8px] bg-white shadow-custom flex items-center justify-center border border-solid border-[#E2E2E2]">
                <img src={vinh_phu} alt="vp" />
              </div>
              <div className="w-1/5 h-[78px] px-[16px] py-[16px] rounded-[8px] bg-white shadow-custom flex items-center justify-center border border-solid border-[#E2E2E2]">
                <img src={vtc2} alt="vtc2" />
              </div>
              <div className="w-1/5 h-[78px] px-[16px] py-[16px] rounded-[8px] bg-white shadow-custom flex items-center justify-center border border-solid border-[#E2E2E2]">
                <img src={vtc6} alt="vtc6" />
              </div>
              <div className="w-1/5 h-[78px] px-[16px] py-[16px] rounded-[8px] bg-white shadow-custom flex items-center justify-center border border-solid border-[#E2E2E2]">
                <img src={vtv3} alt="vtv3" />
              </div>
              <div className="w-1/5 h-[78px] px-[16px] py-[16px] rounded-[8px] bg-white shadow-custom flex items-center justify-center border border-solid border-[#E2E2E2]">
                <img src={vtc} alt="vtc" />
              </div>
            </div>
          </div>
          <div className="block md:hidden lg:hidden mt-4">
            <div className="grid grid-cols-2 w-full gap-2">
              <div className="w-full h-[78px] px-[16px] py-[16px] rounded-[8px] bg-white shadow-custom flex items-center justify-center border border-solid border-[#E2E2E2]">
                <img src={vinh_phu} alt="vp" />
              </div>
              <div className="w-full h-[78px] px-[16px] py-[16px] rounded-[8px] bg-white shadow-custom flex items-center justify-center border border-solid border-[#E2E2E2]">
                <img src={vtc2} alt="vtc2" />
              </div>
              <div className="w-full h-[78px] px-[16px] py-[16px] rounded-[8px] bg-white shadow-custom flex items-center justify-center border border-solid border-[#E2E2E2]">
                <img src={vtc6} alt="vtc6" />
              </div>
              <div className="w-full h-[78px] px-[16px] py-[16px] rounded-[8px] bg-white shadow-custom flex items-center justify-center border border-solid border-[#E2E2E2]">
                <img src={vtv3} alt="vtv3" />
              </div>
              <div className="w-full h-[78px] px-[16px] py-[16px] rounded-[8px] bg-white shadow-custom flex items-center justify-center border border-solid border-[#E2E2E2]">
                <img src={vtc} alt="vtc" />
              </div>
            </div>
          </div>
        </div>
            </div>
        </div>
    );
}